import { yup } from '@framework/validation/initYup.ts';
import { v4 as uuid } from 'uuid';
import { BooleanConditionSchema } from '../../../../../../inputs/expressions-editor/conditions/BooleanConditionSchema.ts';
import { type IAdvancedSelectColumns } from '../IAdvancedSelectColumns.ts';
import { normalizeColumnValue } from '../utils/normalizeColumnValue.ts';

export const widgetAdvancedOptionValueValidator = yup
  .object({
    type: yup
      .string()
      .equals(['option'])
      .default('option')
      .required()
      .label('Tipo'),

    visible: BooleanConditionSchema,
    enabled: BooleanConditionSchema,
  })
  .required()
  .noUnknown();

/**
 * Crea lo schema di validazione per le opzioni del widget AdvancedSingleSelect.
 */
export function getAdvancedSelectOptionSchema(
  columns?: IAdvancedSelectColumns[],
) {
  const valuesShape: Record<string, any> = {};

  for (const col of columns ?? []) {
    valuesShape[col.id] = yup
      .mixed()
      .transform(value => normalizeColumnValue(value, col.type))
      .label(col.label);
  }

  return widgetAdvancedOptionValueValidator.shape({
    id: yup
      .string()
      .default(() => uuid())
      .label('ID'),
    values: yup.object(valuesShape).label('Valori'),
  });
}
